import React, { ReactNode } from 'react';
import { Container } from 'reactstrap';
import Footer from './Footer';
import './Layout.css';

// Layout now includes landmark semantics: main is handled via Container tag attribute in App wrapper.
// A global skip link will be injected from App; this component simply wraps children.

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      {/* main landmark provided here */}
      <Container tag="main" id="main-content" className="content" role="main" aria-labelledby="page-heading">
        {children}
      </Container>
      <Footer />
    </div>
  );
};

Layout.displayName = 'Layout';
